import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getTmsSettingsEffect = (params: any) => {
  return axiosInstance.request({
    url: `${API.MASTER_SETTINGS}/GetTMSSettings`,
    method: 'get',
    params,
  });
};

export const getCustomerDefaultSettingsEffect = ({
  customerKey,
  type,
  parameterName,
}: {
  customerKey: number;
  type?: string;
  parameterName?: string;
}) => {
  return axiosInstance.request({
    url: `${API.MASTER_SETTINGS}/GetCustomerDefaultSettings`,
    method: 'post',
    data: {
      customerKey,
      type,
      parameterName,
    },
  });
};

export const saveTmsSettingsEffect = (data: any) => {
  return axiosInstance.request({
    url: `${API.MASTER_SETTINGS}/SaveTMSSettings`,
    method: 'post',
    data,
  });
};

export const deleteTmsSettingsShipmentRestrictionEffect = (params: any) => {
  return axiosInstance.request({
    url: `${API.MASTER_SETTINGS}/DeleteEarlyShipmentRestriction`,
    method: 'delete',
    params,
  });
};
